export enum SearchMode {
    Everywhere = 0,
    Keys = 1,
    Translations = 2,
    AppVersions = 3
}
